﻿import { expressQuerySelector } from "../../common/html";

export interface ICreateReviewBarDependencies {
	readonly onClick: (stars: number) => void;
	readonly clearActiveBar: () => void;
}

export function createReviewBar(containerEl: HTMLElement, dependencies: ICreateReviewBarDependencies) {
	const { onClick, clearActiveBar } = dependencies;
	const barEl = expressQuerySelector<HTMLElement>(containerEl, ".m-review-bars__review-bar", true);
	const quantityEl = expressQuerySelector<HTMLElement>(containerEl, ".m-review-bars__reviews-quantity", true);
	const enabledClass = "m-review-bars__review-link";
	const disabledClass = "m-review-bars__review-no-link";
	const activeClass = "m-review-bars__review-link--active";
	let startValue = 0;

	const isEnabled = () => containerEl.classList.contains(enabledClass);

	const isDisabled = () => containerEl.classList.contains(disabledClass);

	function getStartValue(): number {
		return +(containerEl.getAttribute("data-star-value") || 0);
	}

	const onClickEvent = () => {
		clearActiveBar();
		containerEl.classList.add(activeClass);
		onClick(startValue);
	};

	const enable = () => {
		if (isDisabled()) containerEl.classList.remove(disabledClass);
		containerEl.classList.add(enabledClass);
		containerEl.addEventListener("click", onClickEvent);
	};

	const updateBarPercentage = (totalNumberOfReviews: number, starAmount: number) => {
		const barActiveEl = expressQuerySelector<HTMLElement>(barEl, ".m-review-bars__review-bar-active", true);
		const percentage = totalNumberOfReviews > 0 ? (starAmount * 100) / totalNumberOfReviews : 0;
		barActiveEl.style.width = percentage + "%";
	};

	const disable = () => {
		if (isEnabled()) containerEl.classList.remove(enabledClass);
		containerEl.classList.add(disabledClass);
		containerEl.removeEventListener("click", onClickEvent);
	};

	const update = (totalNumberOfReviews: number, amount: number) => {
		quantityEl.innerHTML = amount + "";
		updateBarPercentage(totalNumberOfReviews, amount);
		if (amount > 0 && isDisabled()) enable();
		if (amount === 0 && isEnabled()) disable();
	};

	const init = () => {
		deInit();
		startValue = getStartValue();
		if (isEnabled()) containerEl.addEventListener("click", onClickEvent);
	};

	const deInit = () => {
		if (isEnabled()) containerEl.removeEventListener("click", onClickEvent);
	};

	const dispose = () => {
		deInit();
	};

	init();

	return {
		dispose,
		update,
		startValue,
	};
}
